import moment from 'moment';
import helpers from "./_helpers";
import _hub from './_hub';

const createEmptyReservation = function () {
	const _reservation = {
		_Link: [],
		_oid: 0,
		_id: 0,
		_uuid: helpers.fn.createGuid(),
		MultiDate: {
			IsActive: false,
			Sets: [],
			Sum: {
				Total: 0
			}
		},
		Alternatives: [],
		Info: {
			Capacity: {
				AllUnavaible: false,
				Status: '',
				Value: 0
			}
		},
		ProfileInfos: {
			Shipping: {
				Salutation: null,
				Title: null,
				Givenname: null,
				Lastname: null,
				CompanyName: null,
				Communication: {
					Email: null,
					EmailRepeat: null,
					Phone: null,
					Language: _hub.culture
				},
				Address: {
					AdressLine1: null,
					AdressLine2: null,
					PostalCode: null,
					City: null,
					Country: {
						ISOCode: null
					}
				}
			},
			CustomAddressLine: [],
		},
		Referer: {
			Channel: null
		},
		Protection: {
			Password: null
		},
		EventDate: null,
		Discounts: [],
		From: {
			Date: null,
			StartTime: null,
			TimeFrame: null,
		},
		Mode: null,
		Payment: {
			Method: "",
			Paypal: null,
			CreditCard: null,
			Sepa: {
				Owner: null,
				Iban: null,
				BIC: null
			}
		},
		Until: {
			Date: null,
			Shift: null
		},
		Products: [],
		ProductsPerUnit: [],
		Selling: {
			Total: null
		},
		Status: "Pending",
		_Payment: {
			Klarna: {
				AuthorizationToken: null,
				ClientToken: null
			},
			Method: null,
			Provider: null,
			PrePayments: [],
			SessionId: null
		},
		Query: {
			From: {
				Date: null,
				Hour: null,
				Minute: null,
				asDate: () => {
					let date = moment(_reservation.Query.From.Date, "YYYY-MM-DD");
					date = date.add(_reservation.Query.From.Hour, "hours").add(_reservation.Query.From.Minute, "minutes");
					return date.format("YYYY-MM-DDTHH:mm");
				}
			},
			Until: {
				Date: null,
				Hour: null,
				Minute: null,
				asDate: () => {
					if (_reservation.Query.Until.Date === null) return null;
					let date = moment(_reservation.Query.Until.Date, "YYYY-MM-DD");
					date = date.add(_reservation.Query.Until.Hour, "hours").add(_reservation.Query.Until.Minute, "minutes");
					return date.format("YYYY-MM-DDTHH:mm");
				}
			},
			IsTermsAccepted: false,
			IsGdprAccepted: false,
		},
		fn: {
			getProduct(uuid) {
				return _reservation.Info.Products.find(r => r._uuid === uuid);
			},
			getProductType(uuid) {
				const productInfo = _reservation.fn.getProduct(uuid);
				return productInfo.Settings.Type;
			},
			getTariff(uuid) {
				return _reservation.Info.Tariffs.find(r => r._uuid === uuid);
			},
			getSelectedProducts() {
				return _reservation.Products.filter(p => p.Tariffs.some(t => t.Count > 0));
			},
			getSelectedTariffs() {
				const selectedProducts = _reservation.fn.getSelectedProducts();
				return selectedProducts.flatMap(product => product.Tariffs.filter(tariff => tariff.Count > 0));
			},
			createProductsPerUnit() {
				//
				let fnAddProduct = (p) => {
					// Handle each Tariff as own product,
					// If the Tariff has units as well: handle each Unit inside a tariff as own product
					p.Tariffs.filter(c => c.Count > 0).forEach(tariff => {
						if (tariff.Units.length > 0) {
							tariff.Units.forEach(u => {
								const clone = JSON.parse(JSON.stringify(p));
								clone.Count = 1;
								clone.NumberOfPersons = u;

								const affectedTariff = clone.Tariffs.find(c => c.Tariff === tariff.Tariff);
								affectedTariff.Count = 1;
								affectedTariff.NumberOfPersons = u;
								affectedTariff.Occupancy = [];
								clone.Tariffs = [affectedTariff]; // ensure only this tariff is inside the mapping
								for (var a = 0; a < u; a++) {
									affectedTariff.Occupancy.push({
										hasExtendedData: false,
										Person: {
											Givenname: "",
											Lastname: "",
											Communication: {
												Email: null,
												Address: null,
												PostalCode: null,
												City: null
											}
										}
									});
								}
								_reservation.ProductsPerUnit.push(clone);
							});
						} else {
							const clone = JSON.parse(JSON.stringify(p));
							// ensure only this tariff is inside the mapping
							clone.Tariffs = clone.Tariffs.filter(t => t.Tariff === tariff.Tariff);
							_reservation.ProductsPerUnit.push(clone);
						}
					});
				};

				//
				_reservation.ProductsPerUnit = [];
				if (_reservation.MultiDate.IsActive && _reservation.MultiDate.Sets.length > 0) {
					_reservation.MultiDate.Sets.forEach(s => {
						s.Products.forEach(p => fnAddProduct(p));
					});
				} else {
					_reservation.Products
						.filter(p => p.Tariffs.some(t => t.Count > 0))
						.forEach(p => fnAddProduct(p));
				}
			},
			get() {
				//
				if (_reservation.Query.From.Date) _reservation.From.Date = moment(_reservation.Query.From.Date).format("YYYY-MM-DD");
				_reservation.Until = null;

				//
				const clone = JSON.parse(JSON.stringify(_reservation));
				const isMultiSeason = clone.Info.Products.some(p => p.Settings && p.Settings.Type === "MultiSeason");
				if (isMultiSeason) clone.From.TimeFrame = null;
				//
				if (clone.MultiDate.IsActive) {
					// get products from sets
					clone.Products = [];
					clone.MultiDate.Sets.forEach(s => {
						s.Products.forEach(p => {
							clone.Products.push(p);
						});
					});

					//
					delete clone.MultiDate;
				} else {
					clone.Products = clone.ProductsPerUnit;
				}

				const productsForPost = [];

				// 
				clone.Products.forEach(p => {

					p.Tariffs.filter(t => t.Count > 0).forEach(t => {
						// Create "product" for each tariff
						const productClone = JSON.parse(JSON.stringify(p));
						productClone._uuid = productClone.Product;
						if (productClone._RepositoryName !== "Entity.Ticketing.Product") productClone._RepositoryName = "Entity.Ticketing.Product";
						const product = this.getProduct(productClone.Product);
						if (clone.Mode === "Services") {
							productClone.Name = product.Content.Name;
						} else {
							const tariff = this.getTariff(t.Tariff);
							productClone.Name = clone.Mode === 'TimeSlots' ? tariff.Content.Name : product.Content.Name + " - " + tariff.Content.Name;
						}

						//
						productClone.Tariff = t.Tariff;

						productClone.Selling = {
							Count: t.Count,
							NumberOfPersons: t.NumberOfPersons,
							Price: t.Total
						};
						clone.Selling.Total += (t.Total * t.Count);

						const productToPush = {
							...productClone,
							...t
						};
						productToPush.Total = t.Total * t.Count;

						//
						delete productToPush.Position;
						delete productToPush.Product;
						delete productToPush.Count;
						delete productToPush.NumberOfPersons;
						delete productToPush.Units;
						delete productToPush.Tariffs;

						productsForPost.push(productToPush);
					});
				});

				clone.Products = productsForPost;

				// discounts
				const discounts = clone.Discounts.filter(d => d.isSelected);
				clone.Discounts = [];
				discounts.forEach(d => clone.Discounts.push({
					_uuid: d._uuid,
					Content: {
						Name: d.Content.Name
					},
					Amount: d.Amount
				}));
				const isNameEmpty = () => {
					const {
						Givenname,
						Lastname
					} = clone.ProfileInfos.Shipping;
					return !Givenname && !Lastname;
				};
				//
				if (clone.Mode !== "TimeSlots" && isNameEmpty()) {
					clone.ProfileInfos.Shipping.Givenname = clone.Products[0].Occupancy[0].Person.Givenname;
					clone.ProfileInfos.Shipping.Lastname = clone.Products[0].Occupancy[0].Person.Lastname;
				}

				//
				delete clone.Alternatives;
				delete clone.ProfileInfos.Shipping.Communication.EmailRepeat;
				delete clone.Info;
				delete clone.fn;
				delete clone.Query;

				//
				return clone;
			}
		}
	}

	return _reservation;
};

export {
	createEmptyReservation
};